var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"table-data-reference"},[_vm._v(_vm._s(_vm.value.name)+"\n  "),(_vm.value.ref)?_c('ButtonComponent',{attrs:{"tag":"router-link","to":{ name: 'residential-edit', params: { id: _vm.$path('ref', _vm.value), step: 'basis' } },"icon":['fal', 'external-link']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }